import adanaDemirspor from '../images/logos/adana-demirspor-logo.png';
import alanyaspor from '../images/logos/alanyaspor-logo.png';
import ankaragucu from '../images/logos/ankaragucu-logo.png';
import antalyaspor from '../images/logos/antalyaspor-logo.png';
import basaksehir from '../images/logos/basaksehir-logo.png';
import besiktas from '../images/logos/besiktas-logo.png';
import fatihKaragumruk from '../images/logos/fatih-karagumruk-logo.png';
import fenerbahce from '../images/logos/fenerbahce-logo.png';
import galatasaray from '../images/logos/galatasaray-logo.png';
import gaziantepFK from '../images/logos/gaziantep-fk-logo.png';
import hatayspor from '../images/logos/hatayspor-logo.png';
import istanbulspor from '../images/logos/istanbulspor-logo.png';
import kasimpasa from '../images/logos/kasimpasa-logo.png';
import kayserispor from '../images/logos/kayserispor-logo.png';
import konyaspor from '../images/logos/konyaspor-logo.png';
import sivasspor from '../images/logos/sivasspor-logo.png';
import trabzonspor from '../images/logos/trabzonspor-logo.png';
import pendikspor from '../images/logos/pendikspor-logo.png';
import rizespor from '../images/logos/rizespor-logo.png';
import samsunspor from '../images/logos/samsunspor-logo.png';

export const logos = {
  "adana-demirspor": adanaDemirspor,
  "alanyaspor": alanyaspor,
  "ankaragucu": ankaragucu,
  "antalyaspor": antalyaspor,
  "basaksehir": basaksehir,
  "besiktas": besiktas,
  "fatih-karagumruk": fatihKaragumruk,
  "fenerbahce": fenerbahce,
  "galatasaray": galatasaray,
  "gaziantep-fk": gaziantepFK,
  "hatayspor": hatayspor,
  "istanbulspor": istanbulspor,
  "kasimpasa": kasimpasa,
  "kayserispor": kayserispor,
  "konyaspor": konyaspor,
  "sivasspor": sivasspor,
  "trabzonspor": trabzonspor,
  "samsunspor": samsunspor,
  "rizespor": rizespor,
  "pendikspor": pendikspor
};


export const logosForFullName = {
  "Adana Demirspor": adanaDemirspor,
  "Alanyaspor": alanyaspor,
  "Ankaragücü": ankaragucu,
  "Antalyaspor": antalyaspor,
  "Başakşehir": basaksehir,
  "Beşiktaş": besiktas,
  "Fatih Karagümrük": fatihKaragumruk,
  "Fenerbahçe": fenerbahce,
  "Galatasaray": galatasaray,
  "Gaziantep FK": gaziantepFK,
  "Hatayspor": hatayspor,
  "İstanbulspor": istanbulspor,
  "Kasımpaşa": kasimpasa,
  "Kayserispor": kayserispor,
  "Konyaspor": konyaspor,
  "Sivasspor": sivasspor,
  "Trabzonspor": trabzonspor,
  "Samsunspor": samsunspor,
  "Rizespor": rizespor,
  "Pendikspor": pendikspor
};
